export type ColumnHeaderGroup = { label: string; start: number; span: number };

/** Rebuild spans from the actual visible/selected order; never merge separated groups. */
export function getColumnHeaderGroups(labels: readonly (string | undefined)[]): ColumnHeaderGroup[] {
  if (!labels.some(Boolean)) return [];
  const groups: ColumnHeaderGroup[] = [];
  labels.forEach((value, index) => {
    const label = value ?? "";
    const previous = groups.at(-1);
    if (previous?.label === label) previous.span++;
    else groups.push({ label, start: index, span: 1 });
  });
  return groups;
}
